import { useGetLoyaltyRollUpTheRimTimelineEventSummaryQuery } from 'generated/rbi-graphql';
import { useLocale } from 'state/intl';

import { determineEventId, determineRemainingRollsCount } from '../helpers';

interface IUseRollsRemainingProps {
  isAuthenticated: boolean;
}

interface IUseRollsRemaining {
  rollsRemaining: number;
  loading: boolean;
}

export const useRollsRemaining = ({
  isAuthenticated,
}: IUseRollsRemainingProps): IUseRollsRemaining => {
  const { region } = useLocale();
  const localeEventId = determineEventId(region);
  const { data, loading } = useGetLoyaltyRollUpTheRimTimelineEventSummaryQuery({
    variables: { eventId: localeEventId },
    skip: !isAuthenticated || !localeEventId,
    fetchPolicy: 'network-only',
  });
  return {
    loading,
    rollsRemaining: data ? determineRemainingRollsCount(region, data) : 0,
  };
};
